var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 5,
    y: 5,
    fill: "#DFFDC9",
    rx: 28
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    x: 5,
    y: 5,
    stroke: "#F7FFF1",
    strokeWidth: 10,
    rx: 28
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#204603",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.333,
    d: "m21.333 43.5 2.333-2.333m0 0 3.5 3.5 4.084-4.084-3.5-3.5m-4.084 4.084 4.084-4.084m4.795-4.795a6.417 6.417 0 1 0 9.074-9.074 6.417 6.417 0 0 0-9.073 9.073zm0 0-4.795 4.795"
  })));
};
export default SvgKey;